<template>
  <transition name="anima">
    <div
      v-if="popupObj.left.length != 0"
      :class="['window-container', isShow ? 'enter' : 'leave3']"
      ref="windowContainer"
      @touchstart.stop="touchStart"
      @touchend.stop="touchEnd"
    >
      <swiper
        :options="swiperOption"
        ref="mySwiper"
        class="swiper_c"
        @touchmove.native.stop.prevent="touchMove"
      >
        <!-- 这部分放你要渲染的那些内容 -->
        <swiper-slide id="swiperSlide">
          <ul class="one-line-window">
            <li
              v-for="(item, index) in popupObj.left"
              :key="index"
              @click="toLocation(item.link)"
            >
              <div
                class="first_every"
                :style="{ backgroundImage: 'url(' + item.coverPicUrl + ')' }"
              >
                <span
                  v-if="index == 3 && circleBtn == 0"
                  class="left-circle"
                  @click.stop="leftClick"
                ></span>
              </div>
            </li>
          </ul>
        </swiper-slide>
        <swiper-slide class="swiper-slide" ref="secondSwiper">
          <ul
            :class="['three-line-window', secondSwiper == 0 ? 'add-class' : '']"
          >
            <li
              v-for="(item, index) in popupObj.right"
              :key="index"
              @click="toLocation(item.link)"
              :class="[
                index > 3 ? 'mar_bot' : '',
                index % 4 == 0 ? '' : 'mar_left'
              ]"
            >
              <img :src="item.coverPicUrl" alt="" />
            </li>
          </ul>
        </swiper-slide>
      </swiper>
    </div>
  </transition>
</template>
<script>
import { home } from '@/api/ajax';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
export default {
  name: '',
  props: {
    sendDir: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isShow: true,
      secondSwiper: 0,
      popupObj: {
        left: [],
        right: []
      },
      swiperOption: {
        pagination: '.swiper-pagination',
        effect: 'coverflow',
        slidesPerView: 1,
        centeredSlides: true,
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 0,
          modifier: 0
        }
      },
      circleBtn: 0,
      timer: null,
      rightArrayIndex: 0
    };
  },
  methods: {
    // 去每个参数
    toLocation(arg) {
      // 跳转专题的区域
      location.href = arg;
    },
    leftClick() {
      this.$refs.mySwiper.swiper.slideNext();
      this.secondSwiper = 1;
      this.circleBtn = 1;
    },
    touchStart(event) {},
    touchMove(event) {
      if (this.secondSwiper != 1) {
        this.secondSwiper = 1;
      }
    },
    touchEnd(event) {
      if (this.$refs.mySwiper.swiper.activeIndex == 0) {
        this.circleBtn = 0;
        this.secondSwiper = 0;
      } else if (this.$refs.mySwiper.swiper.activeIndex == 1) {
        this.circleBtn = 1;
        this.secondSwiper = 1;
      }
    }
  },
  watch: {
    sendDir(v) {
      if (v == 1) {
        if (this.popupObj.left.length != 0) {
          clearTimeout(this.timer);
          this.timer = null;
          this.isShow = false;
          this.circleBtn = 0;
          this.timer = setTimeout(() => {
            this.secondSwiper = 0;
            this.$refs.mySwiper.swiper.slidePrev();
          }, 300);
        }
      } else if (v == 2) {
        this.isShow = true;
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  created() {
    home.indexAdvList().then(res => {
      if (res.data.data) {
        for (let i = 0; i < res.data.data.length; i++) {
          if (i < 4) {
            this.popupObj.left.push(res.data.data[i]);
          } else {
            this.popupObj.right.push(res.data.data[i]);
          }
        }
      }
    });
  },
  mounted() {},
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
};
</script>
<style lang="less" scoped>
.window-container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: rgba(51, 51, 51, 0.33);
  transition: all 0.3s linear;
  .one-line-window {
    display: flex;
    justify-content: space-between;
    position: relative;
    // margin-top: 4.53rem;
    width: 100%;
    overflow-x: hidden;
    height: 2.27rem;
    li {
      width: 24.7%;
      height: 2.27rem;
      overflow: hidden;
      .first_every {
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
      }
    }
    li:nth-of-type(4) {
      .left-circle {
        position: absolute;
        right: -10%;
        top: 0%;
        width: 1.55rem;
        height: 2.27rem;
        background: rgba(51, 51, 51, 0.4);
        border-radius: 50% 0% 0% 50%;
      }
    }
  }
  .three-line-window {
    position: relative;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap-reverse;
    width: 100%;
    overflow-x: hidden;
    li {
      width: 24.6%;
      height: 2.27rem;
      img {
        width: 100%;
        height: 100%;
      }
      .right-circle {
        position: absolute;
        left: -8%;
        bottom: 8%;
        width: 1.55rem;
        background: rgba(51, 51, 51, 0.1);
        border-radius: 0% 50% 50% 0%;
      }
      .one_four {
        height: 40%;
      }
      .five_eight {
        height: 80%;
      }
      .nine_.twl {
        height: 120%;
      }
    }
    .mar_bot {
      margin-bottom: 0.05rem;
    }
    .mar_left {
      margin-left: 0.4%;
    }
  }
  .add-class {
    height: 2.27rem;
  }
}
.enter {
  bottom: 0rem;
}
.leave1 {
  bottom: -2.27rem;
}
.leave2 {
  bottom: -4.54rem;
}
.leave3 {
  bottom: -6.81rem;
}
// .anima {
//   bottom: 0;
// }
// .anima-enter {
//   bottom: -2.27rem;
// }
// .anima-enter-active,
// .anima-leave-active {
//   transition: all 0.3s linear;
// }
// .anima-leave {
//   bottom: 0rem;
// }
// .anima-leave-active {
//   bottom: -2.27rem;
// }
// .anima1-leave-active {
//   bottom: -4.54rem;
// }
// .anima2-leave-active {
//   bottom: -6.81rem;
// }
.back-first {
  transform: translate3d(0px, 0px, 0px);
}
</style>
<style lang="less">
.swiper_c {
  position: relative !important;
  width: 100% !important;
  .swiper-wrapper {
    display: flex !important;
    align-items: flex-end !important;
    .swiper-slide {
      width: 100% !important;
    }
  }
}
</style>
